/**
 * 轮播图管理
 * 管理小程序首页轮播图
 */
import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function BannerManage() {
  const [banners, setBanners] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [editing, setEditing] = useState(null)
  const [form, setForm] = useState({ title: '', image: '', link: '', sort: 1, status: 'active' })
  const [uploading, setUploading] = useState(false)
  const [loading, setLoading] = useState(true)

  // 获取token
  const getToken = () => localStorage.getItem('cms_token') || localStorage.getItem('boxiaotu_token') || ''
  const authHeaders = () => ({ 'Authorization': `Bearer ${getToken()}`, 'Content-Type': 'application/json' })

  // 加载轮播图数据
  useEffect(() => {
    loadBanners()
  }, [])

  const loadBanners = async () => {
    setLoading(true)
    try {
      const res = await fetch(`${API}/banners`)
      const data = await res.json()
      if (data.success && data.data) {
        setBanners(data.data)
      }
    } catch (err) {
      console.error('加载失败:', err)
    }
    setLoading(false)
  }

  // 上传图片
  const handleUpload = async (e) => {
    const file = e.target.files[0]
    if (!file) return
    if (!file.type.startsWith('image/')) {
      alert('请选择图片文件')
      return
    }
    
    setUploading(true)
    const formData = new FormData()
    formData.append('file', file)
    
    try {
      const res = await fetch(`${API}/upload`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${getToken()}` },
        body: formData
      })
      const data = await res.json()
      if (data.success || data.url) {
        setForm({ ...form, image: data.url || data.data?.url })
        alert('上传成功')
      } else {
        alert(data.error || '上传失败')
      }
    } catch (err) {
      alert('上传失败')
    }
    setUploading(false)
    e.target.value = ''
  }

  // 打开添加弹窗
  const openAdd = () => {
    setEditing(null)
    setForm({ title: '', image: '', link: '', sort: banners.length + 1, status: 'active' })
    setShowModal(true)
  }

  // 打开编辑弹窗
  const openEdit = (banner) => {
    setEditing(banner)
    setForm({ ...banner })
    setShowModal(true)
  }

  // 保存
  const handleSave = async () => {
    if (!form.title) { alert('请填写标题'); return }
    if (!form.image) { alert('请上传图片'); return }
    
    let newBanners
    if (editing) {
      // 编辑
      newBanners = banners.map(b => b.id === editing.id ? { ...form, id: editing.id } : b)
    } else {
      // 添加
      newBanners = [...banners, { ...form, id: Date.now() }]
    }
    
    try {
      const res = await fetch(`${API}/banners`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify({ banners: newBanners })
      })
      const data = await res.json()
      if (data.success) {
        setBanners(newBanners)
        setShowModal(false)
        alert('保存成功！')
      } else {
        alert(data.error || '保存失败')
      }
    } catch (err) {
      alert('保存失败')
    }
  }

  // 删除
  const handleDelete = async (id) => {
    if (!confirm('确定删除这张轮播图？')) return
    const newBanners = banners.filter(b => b.id !== id)
    try {
      const res = await fetch(`${API}/banners`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify({ banners: newBanners })
      })
      const data = await res.json()
      if (data.success) {
        setBanners(newBanners)
        alert('删除成功')
      }
    } catch (err) {
      alert('删除失败')
    }
  }

  // 移动顺序
  const moveUp = async (index) => {
    if (index === 0) return
    const newBanners = [...banners]
    ;[newBanners[index - 1], newBanners[index]] = [newBanners[index], newBanners[index - 1]]
    newBanners.forEach((b, i) => b.sort = i + 1)
    try {
      const res = await fetch(`${API}/banners`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify({ banners: newBanners })
      })
      const data = await res.json()
      if (data.success) {
        setBanners(newBanners)
      }
    } catch (err) {
      alert('排序失败')
    }
  }

  const moveDown = async (index) => {
    if (index === banners.length - 1) return
    const newBanners = [...banners]
    ;[newBanners[index], newBanners[index + 1]] = [newBanners[index + 1], newBanners[index]]
    newBanners.forEach((b, i) => b.sort = i + 1)
    try {
      const res = await fetch(`${API}/banners`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify({ banners: newBanners })
      })
      const data = await res.json()
      if (data.success) {
        setBanners(newBanners)
      }
    } catch (err) {
      alert('排序失败')
    }
  }

  if (loading) {
    return <div style={{ padding: 40, textAlign: 'center' }}>加载中...</div>
  }

  return (
    <div style={{ padding: 20 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h2 style={{ margin: 0 }}>🎠 首页轮播图管理</h2>
          <p style={{ color: '#999', margin: '4px 0 0', fontSize: 13 }}>管理小程序首页轮播图片，建议尺寸 750x400</p>
        </div>
        <button onClick={openAdd} style={{ padding: '10px 20px', background: '#667eea', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}>
          ➕ 添加轮播图
        </button>
      </div>

      <div style={{ display: 'grid', gap: 16 }}>
        {banners.sort((a, b) => a.sort - b.sort).map((banner, index) => (
          <div key={banner.id} style={{ background: '#fff', borderRadius: 12, padding: 16, display: 'flex', gap: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
            <img 
              src={banner.image} 
              alt={banner.title}
              style={{ width: 200, height: 120, objectFit: 'cover', borderRadius: 8 }}
            />
            <div style={{ flex: 1 }}>
              <h3 style={{ margin: '0 0 8px' }}>{banner.title}</h3>
              <p style={{ color: '#666', margin: '0 0 8px', fontSize: 13 }}>
                {banner.link ? `跳转: ${banner.link}` : '无跳转链接'}
              </p>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <span style={{ background: banner.status === 'active' ? '#52c41a20' : '#99920', color: banner.status === 'active' ? '#52c41a' : '#999', padding: '2px 8px', borderRadius: 4, fontSize: 12 }}>
                  {banner.status === 'active' ? '显示中' : '已隐藏'}
                </span>
                <span style={{ color: '#999', fontSize: 12 }}>排序: {banner.sort}</span>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <button onClick={() => moveUp(index)} disabled={index === 0} style={{ padding: '6px 12px', background: '#f0f0f0', border: 'none', borderRadius: 4, cursor: 'pointer' }}>⬆️</button>
              <button onClick={() => moveDown(index)} disabled={index === banners.length - 1} style={{ padding: '6px 12px', background: '#f0f0f0', border: 'none', borderRadius: 4, cursor: 'pointer' }}>⬇️</button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <button onClick={() => openEdit(banner)} style={{ padding: '6px 16px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>编辑</button>
              <button onClick={() => handleDelete(banner.id)} style={{ padding: '6px 16px', background: '#ff4d4f', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>删除</button>
            </div>
          </div>
        ))}
      </div>

      {banners.length === 0 && (
        <div style={{ textAlign: 'center', padding: 60, color: '#999', background: '#fff', borderRadius: 12 }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>📷</div>
          <p>暂无轮播图，点击上方按钮添加</p>
        </div>
      )}

      {/* 添加/编辑弹窗 */}
      {showModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={() => setShowModal(false)}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 28, width: 500 }} onClick={e => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 20px' }}>{editing ? '✏️ 编辑轮播图' : '➕ 添加轮播图'}</h3>
            
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 13, color: '#666' }}>标题 *</label>
              <input value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} placeholder="如：创演体验套餐" style={{ width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' }} />
            </div>
            
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 13, color: '#666' }}>图片 *</label>
              <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                <input value={form.image} onChange={e => setForm({ ...form, image: e.target.value })} placeholder="输入图片URL" style={{ flex: 1, padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }} />
                <label style={{ padding: '10px 16px', background: '#667eea', color: '#fff', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>
                  {uploading ? '上传中...' : '📤 上传'}
                  <input type="file" accept="image/*" onChange={handleUpload} style={{ display: 'none' }} />
                </label>
              </div>
              {form.image && <img src={form.image} alt="" style={{ marginTop: 8, width: '100%', height: 150, objectFit: 'cover', borderRadius: 8 }} />}
            </div>
            
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 13, color: '#666' }}>跳转链接（可选）</label>
              <input value={form.link} onChange={e => setForm({ ...form, link: e.target.value })} placeholder="如：/pages/study-tour/study-tour" style={{ width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' }} />
            </div>
            
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 13, color: '#666' }}>状态</label>
              <select value={form.status} onChange={e => setForm({ ...form, status: e.target.value })} style={{ width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14 }}>
                <option value="active">显示</option>
                <option value="inactive">隐藏</option>
              </select>
            </div>
            
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
              <button onClick={() => setShowModal(false)} style={{ padding: '10px 24px', background: '#f0f0f0', border: 'none', borderRadius: 6, cursor: 'pointer' }}>取消</button>
              <button onClick={handleSave} style={{ padding: '10px 24px', background: '#667eea', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>保存</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
